module.exports = __webpack_public_path__ + "static/media/card1.e659aa32.png";